import type { FaireProductEntity } from "../../entity_types/product";

export const p_9k2emnadu7: FaireProductEntity = {
  token: "p_9k2emnadu7",
  type: "product",
  name: 'Lantern LED Lamp with Chimney-10.5"H',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/6df7f7a3edb586d6d7e12a60e308622dae747aef0ce688d9142520f6991d8fd2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/754d5bddd9b1ff2d9ee7fb5334f3889b98b12d5a05d46f9c9bc27b6ed98fee97.jpeg",
    "https://cdn.faire.com/fastly/696bde36df2af18b9405c0a30129294a7048c972a4972d290b98c89fcb61f928.jpeg",
    "https://cdn.faire.com/fastly/f7022fa50170f98a03607976c22d6798b60e4a7fa80cb40e79574b56099bb852.jpeg",
    "https://cdn.faire.com/fastly/89f4768ed6501c5405d8865bb58ad6948f90e9b0cdd0f52686a0c2599763754b.jpeg",
    "https://cdn.faire.com/fastly/ef224aaf4622154d1cf4463271c97d9ac852c369934848f1df79648c7cd8668b.jpeg",
    "https://cdn.faire.com/fastly/bba0c32f5d3a05db5c255fd970207a28563e4b9ecd0f357de92e336f0de2d8c6.jpeg",
    "https://cdn.faire.com/fastly/7fe67e8e4ea15831a7dcf3ae9ff65d0ffb2384c52ffdd4efd41144b20a87907a.jpeg",
    "https://cdn.faire.com/fastly/0f352ba3b7b742c1174a43cd1b69906da90e65272b2a125f2a93c904eaf109a0.jpeg",
    "https://cdn.faire.com/fastly/80f68085f2e684930020722ed0eeb1dcbda4834ca8b7edcd8768250d8956c4b2.jpeg",
    "https://cdn.faire.com/fastly/59fd95e050932de1d0a0538c1b350abebd9bb45888e50b261f098fbf7507ab8d.jpeg",
    "https://cdn.faire.com/fastly/113778e35ca3fd635554da06d94e122a91154a2208656b318b4b615de17914d7.jpeg",
    "https://cdn.faire.com/fastly/a79ae500d8c48aa559f8e8d492d4f49010700096350bee0b033bcfbcc54b8a20.jpeg",
    "https://cdn.faire.com/fastly/efc236076d26767c2b549278078fa1259d9fa3f2cf4aef05b2304aa5502c5fd8.jpeg",
    "https://cdn.faire.com/fastly/bc5b2786ca583d6d4b7beb603168d8e35c2b66be8a33d6b7a4a88c5e9645083b.jpeg",
    "https://cdn.faire.com/fastly/6bd43c0afc866b91d68109b21369e7d2a3fb17dbf81dd6e61563a995a7154ea0.jpeg",
    "https://cdn.faire.com/fastly/58344a68bb82bd2703c047877a90604b422b43738ca3bbd8071f11ce6b3d8eca.jpeg",
    "https://cdn.faire.com/fastly/a3e83cbe4bf69f439d48a2236a2d0ec13295fde95dc67a33ad1c183047e516af.jpeg",
    "https://cdn.faire.com/fastly/e84fe3dac5e18144acdc552bd5866f598a8f788291226a20246e4f4e812c9423.jpeg",
    "https://cdn.faire.com/fastly/50a21dd455545c3dec51cdbbc18bf27aeba557d55367327f29a4f24b4a486e42.jpeg",
    "https://cdn.faire.com/fastly/9ec74d245290adbf0ad5325538e43a65b610f5ead5e90f9bdccc32cb784c2909.jpeg",
  ],
  priceDollars: 45,
  description:
    "Introducing our modern Lantern LED Lamp with Chimney, and a dimmable bulb. This stylish lantern combines contemporary aesthetics with vintage charm, offering energy-efficient LED lighting with the warm, inviting glow of an Edison bulb. USB Rechargeable. Perfect for indoor or outdoor use, it adds a touch of elegance and ambiance to any setting. Available in several colours.",
  tags: [],
  msrpDollars: 90,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:06.621Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
